import React, { useState, useEffect } from "react";
import Header from "./Header";
import ReactPlayer from "react-player/vimeo";

const LandingSection = ({ data }) => {
  const [utahTime, setUtahTime] = useState("");
  const [isClient, setIsClient] = useState(false);
  const [playerWidth, setPlayerWidth] = useState("100vw");
  const [videoReady, setVideoReady] = useState(false); // <-- New state

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth;

      if (width <= 640) {
        setPlayerWidth("300vh"); // full width on mobile
      } else if (width <= 1024) {
        setPlayerWidth("400vh"); // full width on tablet
      } else if (width <= 1660) {
        setPlayerWidth("200vw"); // full width on tablet
      } else {
        setPlayerWidth("100vw"); // full width on desktop
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    setIsClient(true);
    const updateTime = () => {
      const options = {
        timeZone: "America/Denver",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      const formatter = new Intl.DateTimeFormat("en-US", options);
      setUtahTime(formatter.format(new Date()));
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const backgroundContent = data || "https://vimeo.com/1089657728";

  return (
    <div className="relative w-full min-h-screen h-screen overflow-hidden flex flex-col justify-between text-white">
      {/* Video or placeholder */}
      <div className="absolute inset-0 z-0">
        {!videoReady && (
          <img
            src="/img/placeholder1.webp" // Make sure this image exists
            alt="Loading..."
            className="w-full h-full object-cover"
          />
        )}

        {isClient && (
          <ReactPlayer
            url={backgroundContent}
            playing
            loop
            muted
            playbackRate={0.6}
            width={playerWidth}
            height="100vh"
            style={{
              position: "absolute",
              minHeight: "100vh",
              top: 0,
              left: 0,
              pointerEvents: "none",
            }}
            playsinline
            onStart={() => setVideoReady(true)} // <-- Hide image when ready
            config={{
              vimeo: {
                playerOptions: {
                  background: true,
                  responsive: true,
                },
              },
            }}
          />
        )}
      </div>

      <div className="absolute inset-0 bg-black/0 z-1" />

      <div className="relative z-2">
        <Header />
      </div>

      <div
        className="flex justify-center mt-[27rem] relative"
        style={{ textShadow: "2px 2px 4px rgba(0,0,0,1)" }}
      ></div>

      <div
        className="relative -mt-[15rem] flex flex-col items-center justify-center text-center px-4 flex-1"
        style={{ textShadow: "2px 2px 4px rgba(0,0,0,1)" }}
      >
        <div className="text-white -mt-[8rem] sm:-mt-[0rem] text-lg sm:text-lg md:text-2xl lg:text-2xl text-center font-extrabold font-mono">
          {utahTime} MDT
        </div>
        <p className="text-[#facc15] text-base sm:text-xl font-bold">
          Welcome to UTahData.org
        </p>
        <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium leading-tight">
          Explore Utah By The Numbers
        </h1>
      </div>
    </div>
  );
};

export default LandingSection;
